module.exports = __webpack_public_path__ + "static/img/jiansuo.49ac0512.png";